module.exports = __webpack_public_path__ + "img/logo_ey2.3ceb19b0.png";